/**
 * Wraps a click handler so it also fires on keyboard activation (Enter or Space),
 * for making non-interactive elements (e.g. clickable divs) keyboard accessible.
 * Pair with `role="button"` and `tabIndex={0}` on the element.
 *
 * @param {(event: KeyboardEvent) => void} handler - the action to run on activation
 * @returns {(event: KeyboardEvent) => void} an onKeyDown handler
 */
const handleKeyboardClick = (handler) => (event) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    handler(event);
  }
};

export default handleKeyboardClick;
